import {
  Button,
  Checkbox,
  DatePicker,
  Drawer,
  Form,
  Input,
  Modal,
  Popconfirm,
  Select,
} from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getPage, getParamValue } from "../../utils/index";
import { useServiceTypeOptions } from "../../../src/hooks/useServiceTypeOptions";
import Empty from "../common/Empty";
import moment from "moment";
import { responseNotification } from "../../utils/notify";
import { useSelector } from "react-redux";
import Loader from "../common/Loader";
import styles from "../../styles/tailwind/List.module.css";
import { EyeOutlined, SearchOutlined, SwapOutlined } from "@ant-design/icons";
import Pagination from "../common/Pagination";
import BreadCrumb from "../Layouts/Breadcrumb";
const { RangePicker } = DatePicker;
const shopSettleRequstOrderList = () => {
  const { driverInfo, token } = useSelector(
    (state) => (state as any)?.authReducer
  );
  const initialState = useSelector((state) => (state as any)?.authReducer);
  const [type, setType] = useState(initialState?.type);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [orderVisible, setOrderVisible] = useState(false);
  const [indeterminate, setIndeterminate] = useState(true);
  const [checkedList, setCheckedList] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const { serviceTypeOptions, getServiceTypeOptions } = useServiceTypeOptions();
  const [selectedOrder, setSelectedOrder] = useState<any>();
  const [selectedOrderId, setSelectedOrderId] = useState<any>([]);
  const [limit, setLimit] = useState(16);
  const [showSearch, setShowSearch] = useState(true);
  const [orderData, setOrderData] = useState<any>({
    loading: false,
    data: null,
  });
  console.log('orderData ===',orderData);
  const [range, setRange] = useState<any>({
    from: null,
    to: null,
  });
  const [selectedUser, setSelectedUser] = useState(undefined);
  const route = useParams();

  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const showDrawer = () => {
    setOrderVisible(true);
  };
  const getSettledRequestOrders = useCallback(async () => {
    const from = moment(range.from)?.toISOString();
    const to = moment(range.to)?.toISOString();
    setOrderData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
    axios
      .get(
        `${encodedUri}/merchant-settlement/settlement-requested-from-shop` +
          `?shopId=${(route as any)?.shopId || ``}` +
          (from ? `&startAt=${from}` : ``) +
          (to ? `&endAt=${to}` : ``) +
          `&page=${page || 0}` +
          `&limit=${limit || 16}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setOrderData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setOrderData({ loading: false, data: [] });
        console.error("Users: Error", err);
      });
  }, [range, route, page, limit]);


  const reseAllFieldData = () => {
    form?.resetFields();
    setRange({
      from: null,
      to: null,
    });
  };

  const onClose = () => {
    setOrderVisible(false);
  };
  useEffect(() => {
    getServiceTypeOptions();
  }, [getServiceTypeOptions]);

  useEffect(() => {
    getSettledRequestOrders();
  }, [getSettledRequestOrders]);

  return (
    <React.Fragment>
      <BreadCrumb
        title={`Settled Order List`}
        subTitle={`${
          orderData?.data?.totalElements ||
          orderData?.data?.shopSettlementRequests?.length ||
          0
        } Brand(s)`}
        extra={[
          <Button
            type="dashed"
            shape="circle"
            onClick={() => setShowSearch(!showSearch)}
            key={1}
          >
            <SearchOutlined />
          </Button>,
        ]}
      />
      {showSearch && (
        <div className={`${styles.searchBox}`}>
          <Form form={form} layout="inline" className={styles.formInline}>
            <Form.Item name="range">
              <RangePicker
                defaultValue={
                  range.from != null && range.to != null
                    ? [moment(range.from), moment(range.to)]
                    : null
                }
                onChange={(e, f) => {
                  setRange({
                    from: moment.utc(f[0])?.toISOString(),
                    to: moment.utc(f[1])?.toISOString(),
                  });
                }}
                showTime={{
                  hideDisabledOptions: true,
                  defaultValue: [
                    moment("00:00:00", "HH:mm:ss"),
                    moment("23:59:59", "HH:mm:ss"),
                  ],
                }}
                inputReadOnly
                allowClear
              />
            </Form.Item>
          </Form>
          <Button
            type="primary"
            danger
            size="large"
            htmlType="reset"
            onClick={reseAllFieldData}
          >
            Reset
          </Button>
        </div>
      )}

      <div className={`content-body`}>
        <div className="bg-white shadow-lg shadow-gray-200 rounded-2xl p-2">
          <table className={styles.mainTable}>
            <thead className="bg-white border-b">
              <tr>
                <th scope="col">Date & Time</th>
                <th scope="col">Amount</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            {orderData?.loading ? (
              <Loader />
            ) : (
              <tbody>
                {orderData?.data?.shopSettlementRequests?.length ? (
                  orderData?.data?.shopSettlementRequests?.map(
                    (order: any, index: any) => (
                      <tr
                        className="border-t hover:bg-gray-100"
                        key={index}
                        onClick={() => setSelectedUser(order)}
                      >
                        <td>
                          <span className="font-medium text-gray-500 ml-2">
                            {moment(order?.createdAt).format("lll")}
                          </span>
                        </td>
                        <td>
                          <span className="font-medium text-gray-500 ml-2">
                            &#2547;{order?.amount}
                          </span>
                        </td>
                        <td>
                          <span className="font-medium text-gray-500 ml-2">
                            {order?.status}
                          </span>
                        </td>
                        <td>
                          <Button
                            shape="round"
                            type="dashed"
                            className="bg-white mr-1"
                            onClick={() =>
                              navigate(
                                `/my-shop/${
                                  order?.id
                                }/settled-orders/details`
                              )
                            }
                          >
                            <EyeOutlined />
                          </Button>
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td>
                      <Empty />
                    </td>
                  </tr>
                )}
              </tbody>
            )}
          </table>
          <Pagination
            {...orderData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default shopSettleRequstOrderList;
